import { render } from "./addblog.vue?vue&type=template&id=626e648c"
import script from "./addblog.vue?vue&type=script&lang=js"
export * from "./addblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__